import crypto from 'crypto'

const _self = {
  issueAuth: () => crypto.randomBytes(16).toString('hex'),
  salt: () => crypto.randomBytes(4).toString('hex'),
  hmac: (salt) => crypto.createHmac('sha512', salt),
  hex: (password, salt) => {
    const hash = _self.hmac(salt) // Hashing algorithm sha512
    hash.update(password)

    const value = hash.digest('hex')
    return value
  },
  hash: (password) => {
    const salt = _self.salt() // Pick a random salt
    const hash = _self.hex(password, salt)

    return { salt, hash }
  },
  isHashSame: (password, salt, expectedHash) => {
    const hash = _self.hex(password, salt)
    return (expectedHash === hash)
  }
}

export default _self
